import type { RichContent, Node_Type } from '@wix/ricos';
import { getPluginData, toPlainText } from '@wix/ricos';

export async function getCustomTabBIData(content?: RichContent) {
  if (!content) {
    return {
      tabDescription: undefined,
      filesCnt: 0,
      imgCnt: 0,
      linksCnt: 0,
      videosCnt: 0,
    };
  }

  return {
    tabDescription: await toPlainText(content),
    filesCnt: getPluginData(content, 'FILE' as Node_Type).length,
    imgCnt: getPluginData(content, 'IMAGE' as Node_Type).length,
    videosCnt: getPluginData(content, 'VIDEO' as Node_Type).length,
    linksCnt: getPluginData(content, 'LINK_PREVIEW' as Node_Type).length,
  };
}
